import React from 'react';

import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

import { ArrowUpRight, Star, Heart, MessageCircle } from 'lucide-react';



const Homesucces = () => {

  return (

    <section className="relative min-h-screen w-full bg-[#1976D2] px-6 lg:px-12 py-12 lg:py-20 font-sans overflow-hidden flex items-center justify-center">

      {/* Background Decorative Element */}

      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">

        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-blue-400/20 blur-[120px] rounded-full" />

      </div>



      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">

        

        {/* Left Content Column */}

        <div className="z-10 text-white text-center lg:text-left order-2 lg:order-1">

          <header className="mb-8 lg:mb-12">

            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.1] tracking-tight relative inline-block">

              Your growth is <br />

              <span className="relative inline-block">

                our mission

                <svg className="absolute -bottom-2 lg:-bottom-4 left-0 w-full" viewBox="0 0 300 20" fill="none">

                  <path d="M5 15Q150 5 295 15" stroke="white" strokeWidth="6" strokeLinecap="round"/>

                </svg>

              </span>

              <div className="hidden md:block absolute -top-12 lg:-top-16 right-[-10%] lg:right-[5%] animate-bounce">

                <ArrowUpRight size={56} className="rotate-[15deg] text-[#FFD54F]" />

              </div>

            </h1>

          </header>



          <div className="space-y-6 lg:space-y-8 max-w-xl mx-auto lg:mx-0 text-blue-50">

            <h2 className="text-3xl lg:text-4xl font-semibold text-white">You deserve better.</h2>

            <p className="text-lg lg:text-xl leading-relaxed opacity-90">

              Peer2Learn connects learners aged 8+ with skilled peer tutors. 

              We believe in proactive teams that embrace complexity and flex to your 

              unique learning journey.

            </p>



            <div className="pt-4">
              <Link to="/enroll">

              <button className="bg-[#1936D9] shadow-xl text-white px-10 lg:px-12 py-4 lg:py-5 rounded-full text-xl lg:text-2xl font-black hover:shadow-[0_20px_50px_rgba(0,0,0,0.4)] transition-all active:scale-95 flex items-center gap-3 mx-auto lg:mx-0 group">

                Start Your Journey

                <ArrowUpRight className="group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" strokeWidth={3} />

              </button>
</Link>
            </div>

          </div>

        </div>



        {/* Right 3D Visual Column */}

        <div className="relative order-1 lg:order-2 w-full max-w-[550px] lg:max-w-none mx-auto" style={{ perspective: "1500px" }}>

          <motion.div 

            initial={{ rotateY: 15, rotateX: 8, y: 20 }}

            animate={{ rotateY: -5, rotateX: -2, y: -20 }}

            transition={{ duration: 5, repeat: Infinity, repeatType: "reverse", ease: "easeInOut" }}

            className="relative bg-white rounded-[40px] lg:rounded-[60px] p-8 lg:p-12 shadow-[50px_50px_0px_rgba(0,0,0,0.1)] border border-white/50 flex flex-col items-center"

          >

            {/* Step Progress Section */}

            <div className="w-full relative mb-16 lg:mb-20 h-32 lg:h-40">

               <div className="absolute inset-0 flex items-center justify-center pointer-events-none -top-4">

                  <span className="text-[160px] lg:text-[220px] font-black text-[#1976D2] opacity-10">P</span>

               </div>



               <svg className="absolute top-0 left-0 w-full h-full pointer-events-none z-0" viewBox="0 0 400 120" preserveAspectRatio="none">

                  <motion.path 

                    d="M50 80 Q 200 -10 350 80" 

                    stroke="black" 

                    strokeWidth="3" 

                    strokeDasharray="10 10" 

                    fill="none" 

                    animate={{ strokeDashoffset: [0, -20] }}

                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}

                  />

               </svg>



               <div className="flex justify-between items-start w-full px-2 lg:px-4 relative z-10">

                  <div className="w-16 h-16 lg:w-20 lg:h-20 bg-[#1976D2] rounded-full flex items-center justify-center shadow-lg border-2 border-white shrink-0">

                    <span className="text-[8px] lg:text-[10px] font-black text-white text-center leading-tight">EXPLORE</span>

                  </div>

                  <div className="w-16 h-16 lg:w-20 lg:h-20 bg-[#1976D2] rounded-full flex items-center justify-center shadow-lg border-2 border-white -mt-6 lg:-mt-8 shrink-0">

                    <span className="text-[8px] lg:text-[10px] font-black text-white text-center leading-tight">LEARN</span>

                  </div>

                  <div className="w-16 h-16 lg:w-20 lg:h-20 bg-[#1976D2] rounded-full flex items-center justify-center shadow-lg border-2 border-white shrink-0">

                    <span className="text-[8px] lg:text-[10px] font-black text-white text-center leading-tight">CONNECT</span>

                  </div>

               </div>



               <div className="text-center w-full mt-6 relative z-10">

                  <p className="text-2xl lg:text-3xl font-bold tracking-tighter text-gray-800">— 100% SUCCESS —</p>

               </div>

            </div>



            {/* Performance Metrics Section */}

            <div className="w-full space-y-8">

                {/* Accuracy Card */}

                <div className="flex items-center gap-4 lg:gap-6 relative">

                    <Star className="absolute -top-10 -left-4 text-black" size={28} />

                    <MessageCircle className="absolute -top-10 right-1/4 text-black" size={28} />

                    

                    <div className="relative shrink-0">

                      <div className="w-24 h-24 lg:w-32 lg:h-32 rounded-full border-[6px] lg:border-[8px] border-[#1976D2] overflow-hidden bg-white shadow-xl">

                        {/* Replaced Icon with Real Image */}

                        <img 

                          src="Gemini_Generated_Image_ci6d0nci6d0nci6d.png" 

                          alt="Tutor" 

                          className="w-full h-full object-cover"

                        />

                      </div>

                    </div>



                    <div className="flex-1 bg-white border-[3px] border-[#1976D2] rounded-[25px] lg:rounded-[35px] p-4 lg:p-6 shadow-sm relative">

                        <span className="font-bold text-base lg:text-lg block mb-2">TRUST</span>

                        <div className="w-full bg-[#E0F7FA] h-4 lg:h-5 rounded-full overflow-hidden p-1 shadow-inner">

                            <motion.div 

                              initial={{ width: 0 }}

                              animate={{ width: "100%" }}

                              transition={{ duration: 1.5, ease: "easeOut" }}

                              className="bg-[#00ACC1] h-full rounded-full"

                            />

                        </div>

                        <div className="absolute -top-4 -right-4 w-12 h-12 lg:w-14 lg:h-14 rounded-full border-[3px] border-black bg-[#B2EBF2] flex items-center justify-center font-black text-xs lg:text-sm shadow-md">

                            100%

                        </div>

                    </div>

                </div>



                {/* Response Time Card */}

                <div className="bg-white border-[3px] border-[#1976D2] rounded-[25px] lg:rounded-[35px] p-4 lg:p-6 shadow-sm relative">

                    <Heart className="absolute -top-8 left-1/4 text-black fill-current" size={24} />

                    <div className="flex justify-between items-center mb-3">

                        <span className="font-bold text-base lg:text-lg">Tutor Response Time</span>

                        <span className="text-xs lg:text-sm font-black text-gray-600">0 MIN 1 SEC</span>

                    </div>

                    <div className="w-full bg-[#E0F7FA] h-4 lg:h-5 rounded-full overflow-hidden p-1 shadow-inner">

                        <motion.div 

                            initial={{ width: 0 }}

                            animate={{ width: "100%" }}

                            transition={{ duration: 1.5, delay: 0.3, ease: "easeOut" }}

                            className="bg-[#00ACC1] h-full rounded-full"

                        />

                    </div>

                    <div className="absolute -top-4 -right-4 w-12 h-12 lg:w-14 lg:h-14 rounded-full border-[3px] border-black bg-[#B2EBF2] flex items-center justify-center font-black text-xs lg:text-sm shadow-md">

                        100%

                    </div>

                </div>

            </div>

          </motion.div>



          <div className="absolute -bottom-10 lg:-bottom-20 -right-10 lg:-right-20 -z-10 animate-pulse">

             <div className="w-48 lg:w-64 h-48 lg:h-64 bg-[#FFD54F] rounded-full blur-[80px] lg:blur-[100px] opacity-20" />

          </div>

        </div>

      </div>

    </section>

  );

};



export default  Homesucces;